export const homeEventsEnLocale = {
  'homeEvents.draft': 'Not published',
  'homeEvents.upcomingEvents': 'Upcoming events',
  'homeEvents.concerts': 'Concerts',
  'homeEvents.family': 'Family',
  'homeEvents.sports': 'Sports',
  'homeEvents.art&Theatre': 'Art & Theatre',
  'homeEvents.viewMore': 'View more',
  'homeEvents.event': 'dates',

  'homeEvents.soldOut': 'Sold out',
  'homeEvents.comingSoon': 'Coming soon',
  'homeEvents.boxOffice': 'Only box office',
  'homeEvents.cancelled': 'Cancelled',
  'homeEvents.preSale': 'Pre-sale',
} as const;

export const homeEventsEsLocale = {
  'homeEvents.draft': 'No publicado',
  'homeEvents.upcomingEvents': 'Próximos eventos',
  'homeEvents.concerts': 'Conciertos',
  'homeEvents.family': 'Diversión',
  'homeEvents.sports': 'Deportivos',
  'homeEvents.art&Theatre': 'Arte & Teatro',
  'homeEvents.viewMore': 'Ver más',
  'homeEvents.event': 'fechas',

  'homeEvents.soldOut': 'Agotado',
  'homeEvents.comingSoon': 'Próximamente',
  'homeEvents.boxOffice': 'Solo taquilla',
  'homeEvents.cancelled': 'Cancelado',
  'homeEvents.preSale': 'Preventa',
} as const;
